import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  makeStyles
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  close: {
    id: "participant-layout.mute-confirm.close",
    defaultMessage: "Close"
  }
});

const useStyles = makeStyles({
  surface: {
    maxWidth: "500px"
  }
});

export function ParticipantMuteConfirmDialog({ participant, onClose, onConfirm }) {
  const styles = useStyles();
  const intl = useIntl();
  const confirmMute = () => {
    onConfirm?.();
    onClose?.();
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogSurface className={styles.surface} data-participant-mute-confirm-dialog="">
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="transparent"
                aria-label={intl.formatMessage(messages.close)}
                icon={<Dismiss24Regular />}
                onClick={onClose}
              />
            }
          >
            <FormattedMessage
              id="participant-layout.mute-confirm.title"
              defaultMessage="Mute {displayName}?"
              values={{ displayName: participant.displayName }}
            />
          </DialogTitle>
          <DialogContent>
            <FormattedMessage
              id="participant-layout.mute-confirm.description"
              defaultMessage="This will turn off their microphone for everyone."
            />
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onClose}>
              <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
            </Button>
            <Button appearance="primary" data-participant-mute-confirm-button="" onClick={confirmMute}>
              <FormattedMessage id="participant-layout.mute-confirm.confirm" defaultMessage="Mute" />
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

ParticipantMuteConfirmDialog.propTypes = {
  participant: PropTypes.shape({
    displayName: PropTypes.string.isRequired
  }).isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};
